import {
  GET_CURRENCY_PENDING,
  GET_CURRENCY_FULFILLED,
  GET_CURRENCY_REJECTED,
} from '../actions/types';

const initialState = {
  data: [],
  loading: false,
  error: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_CURRENCY_PENDING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case GET_CURRENCY_FULFILLED:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: false,
      };
    case GET_CURRENCY_REJECTED:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    default:
      return state;
  }
}
